import { c as _c } from "react/compiler-runtime";
import React from "react";
import FeatureGrid, { FeatureGridItem } from "@/components/common/FeatureGrid";
export default function ShopifyEndToEndServices() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const items = [{
      id: "estore-customization",
      title: "eStore Customization Services",
      description: "Want to optimize your existing Shopify stores as per the current market trends? Hire dedicated Shopify developers for complete customization services of your eStores.",
      icon: "/images/crm/key-benefit-1.png",
      bgColor: "#fdf7fc"
    }, {
      id: "shopify-integration",
      title: "Shopify Integration Services",
      description: "Hire an expert Shopify developer to enhance the functionalities of your feature-rich Shopify Stores. From payment gateways to CRM and ERP, we can help you integrate third-party APIs seamlessly.",
      icon: "/images/shopify/service-2.svg",
      bgColor: "#f3edf9"
    }, {
      id: "theme-development",
      title: "Theme Development",
      description: "Hire qualified Shopify designers and programmers from The Dezine to craft the most intuitive and highly responsive Shopify themes for your websites and mobile applications.",
      icon: "/images/shopify/service-3.svg",
      bgColor: "#fdedef"
    }, {
      id: "design-and-development",
      title: "Shopify Design and Development",
      description: "Looking to develop perfectly crafted Shopify Stores for your business? Hire remote Shopify programmers and coders from India to design visually appealing, robust Shopify websites and applications.",
      icon: "/images/shopify/service-4.svg",
      bgColor: "#f1f8ff"
    }, {
      id: "maintenance-services",
      title: "Shopify Maintenance Services",
      description: "Optimizing your Shopify store is no more a problem when you hire Shopify coders from The Dezine. Our Shopify experts provide 24/7 support for smoother operations and maintenance of your stores.",
      icon: "/images/shopify/service-5.svg",
      bgColor: "#f2f7fd"
    }, {
      id: "migration-services",
      title: "Shopify Migration Services",
      description: "Want to move your existing store to Shopify? Get end-to-end support for smoother Shopify Migration of your store by hiring experienced Shopify developers from The Dezine.",
      icon: "/images/shopify/service-6.svg",
      bgColor: "#fefaf6"
    }];
    t0 = <FeatureGrid heading="Hire our Shopify Developers for End-to-End Services" description="Bring your business to the online market in full fledge with custom Shopify development services from The Dezine. Hire pre-vetted Shopify experts to leverage their years of business expertise in developing custom Shopify solutions for your business." items={items} raisedColumn={1} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}